module.exports = __webpack_public_path__ + "static/media/Roland_Lindt.0167115a.jpeg";